import type { AuthRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type RevertUserActivationInput = {
	token: string;
};

export type RevertUserActivationUseCase = UseCase<RevertUserActivationInput, void>;

export function revertUserActivationBuilder(
	authRepository: AuthRepository
): RevertUserActivationUseCase {
	return async function revertUserActivation(input: RevertUserActivationInput): Promise<void> {
		const token = stringValueObject().validate('token', input.token);

		await authRepository.revertUserActivation(token);
	};
}
